import { universalTransferDocumentTypes } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { singleList as classificationTypesSingleList } from "sources/books/classificationTypes";

const inputProps = {
    labelWrapper: "col-12 col-form-label col-form-label-sm text-muted",
    fieldWrapper: "col-12",
};

export const config = {
    documentDate: {
        label: "Дата документа",
        inputProps: { name: "documentDate", type: "date" },
        inPortal: true,
        wrapper: "col-12",
        ...inputProps,
    },
    type: {
        label: "Статус УПД",
        inputProps: { name: "type" },
        options: universalTransferDocumentTypes,
        required: true,
        validators: [requiredField],
        unClearable: true,
        ...inputProps,
    },
    classificationTypeId: {
        label: "Тип номенклатуры",
        inputProps: { name: "classificationTypeId" },
        url: classificationTypesSingleList,
        propName: "name",
        menuPortalTarget: document.body,
        required: true,
        validators: [requiredField],
        ...inputProps,
    },
};

export const initialState = {
    ...getInitialStateFromConfig(config),
    type: "InvoiceAndTransfer",
};
